class FileReadBase64
  @$inject = []

  scope:
    fileReadBase64: '='
  link: (scope, element, attrs) ->
    element.bind("change", (changeEvent)->

      reader = new FileReader()

      reader.onload = (loadEvent) ->
        scope.$apply(->
          scope.fileReadBase64 = loadEvent.target.result
        )

      reader.readAsDataURL(changeEvent.target.files[0])
    )
    null


angular.module('eficienciaFiscalModule').directive('fileReadBase64', -> new FileReadBase64())
